import request from '@/utils/request'
import { mockRoleList, mockUserProfile } from '@/mock/mockData'

function ok(data = null, message = 'ok') {
  return Promise.resolve({ success: true, message, data })
}

export function login(data) {
  return ok({ token: 'mock-access-token' })
}

export function logout() {
  return ok()
}

export function getProfile() {
  return ok(mockUserProfile())
}

export function add() {
  return request({
    url: '/sys_entry',
    method: 'post'
  })
}

// 获取角色
export function roleList() {
  return ok({ list: mockRoleList() })
}

// 修改密码
export function up(data) {
  return ok()
}

// 验证token
export function checkToken() {
  return ok()
}

// 获取文件
export function checkFile(id) {
  return request({
    url: '/sys_assets/' + id,
    method: 'get'
  })
}

export function updateLangCode(data) {
  return ok()
}
